export interface IDerapiVendor {
  vendorCode: string;
  vendorName: string;
}

// Vendors Derapi supports through its end-user OAuth Join flow (POST /join/flows ->
// GET /join/flows/{id}/authorize -> vendor's own consent page). This is deliberately NOT
// Derapi's full vendor list - installer/API-key vendors (ChargePoint, SolarEdge apikey, EG4,
// Sol-Ark, etc.) connect through a separate mechanism (Vendor Credentials + Enrollment, no
// end-user consent screen) and don't belong in this picker.
export const derapiJoinVendors: IDerapiVendor[] = [
  { vendorCode: "enphase", vendorName: "Enphase" },
  { vendorCode: "tesla", vendorName: "Tesla" },
  { vendorCode: "sma", vendorName: "SMA" },
  { vendorCode: "solaredge", vendorName: "SolarEdge" },
  { vendorCode: "solis", vendorName: "Solis" },
  { vendorCode: "foxess", vendorName: "FoxESS" },
];
